import React from 'react';

import { Space } from 'antd';

import { DROPDOWN_WIDTHS } from '@/shared/lib/constants/ui';

import { useFilterStore } from '@/entities/discovery';
import { useDisplaySettingsStore } from '@/entities/display-settings';

import { AssetTypeDropdown } from '@/widgets/discovery/AssetTypeDropdown';
import { CertificationDropdown } from '@/widgets/discovery/CertificationDropdown';
import { DataSourceDropdown } from '@/widgets/discovery/DataSourceDropdown';
import { DomainDropdown } from '@/widgets/discovery/DomainDropdown';
import { OwnerDropdown } from '@/widgets/discovery/OwnerDropdown';
import { TagDropdown } from '@/widgets/discovery/TagDropdown';
import { TierDropdown } from '@/widgets/discovery/TierDropdown';

import styles from './TopFilterBar.module.css';

type TopFilterBarProps = {
  className?: string;
  align?: 'left' | 'center' | 'right';
};

export const TopFilterBar: React.FC<TopFilterBarProps> = ({ className, align = 'left' }) => {
  const { getActiveFilterCount } = useFilterStore();
  const showOwners = useDisplaySettingsStore((state) => state.showOwners);

  const activeFilterCount = getActiveFilterCount();

  const handleClearAll = () => {
    useFilterStore.getState().clearAllFilters();
  };

  const alignClass = align === 'left' ? styles.alignLeft : align === 'right' ? styles.alignRight : styles.alignCenter;

  return (
    <div className={`${styles.topFilterBar} ${alignClass} ${className || ''}`}>
      <div className={styles.filterContainer}>
        <Space size="small" className={styles.filterButtons}>
          <AssetTypeDropdown width={DROPDOWN_WIDTHS.ASSET_TYPE} />
          <DataSourceDropdown />
          <DomainDropdown />
          {showOwners && <OwnerDropdown />}
          <TagDropdown width={DROPDOWN_WIDTHS.TAG} />
          <TierDropdown width={DROPDOWN_WIDTHS.TIER} />
          <CertificationDropdown width={DROPDOWN_WIDTHS.CERTIFICATION} />
          <button
            type="button"
            onClick={handleClearAll}
            className={`${styles.clearAllButton} ${activeFilterCount === 0 ? styles.disabled : ''}`}
            disabled={activeFilterCount === 0}>
            전체 필터 초기화
          </button>
        </Space>
      </div>
    </div>
  );
};
